"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BridgeTypes;
(function (BridgeTypes) {
    BridgeTypes["COURSE"] = "course";
    BridgeTypes["PROGRAM"] = "program";
    BridgeTypes["LIVE_COURSE"] = "live-training";
})(BridgeTypes = exports.BridgeTypes || (exports.BridgeTypes = {}));
//# sourceMappingURL=bridge-types.js.map